<template>
  <div class="mTips pr text_center">
    <div class="titleBox">
      <p class="title color_40 f_20 font_w_b">复制链接到电脑端浏览器</p>
      <p class="text color_9c f_14">立即查看更多优秀简历</p>
    </div>
    <div class="linkBox flex f_16" v-clipboard:copy="detailUrl" v-clipboard:success="onCopyUrl" v-clipboard:error="onCopyUrlError">
      <div class="link flex1 color_blue ellipsis">{{detailUrl}}</div>
      <div class="button color_blue">复制</div>
    </div>
    <img src="https://files.wondercv.com/mobile/orders/assistant-qr-code.png" alt="" class="qrCode">
    <div class="tipsText color_40 f_16">
      <p>联系专属 超级招聘官KiKi </p>
      <p>免费发职位收简历</p>
    </div>
  </div>
</template>
<script>

export default {
  data(){
    return {
      detailUrl: 'https://hr.wondercv.com',
    }
  },
  created(){
    this.addMeta('viewport','width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0,user-scalable=no')
  },
  methods:{
    addMeta(name,content){//手动添加mate标签
      let meta = document.createElement('meta');
        meta.content=content;
        meta.name=name;
        document.getElementsByTagName('head')[0].appendChild(meta);
    },
    onCopyUrl(){
      this.$message({
        message:'复制成功！',
        type:'success'
      })
    },
    onCopyUrlError(){
      this.$message({
        message:'复制失败，请手动复制！',
        type:'error'
      })
    },
  },
}
</script>
<style lang="scss" scoped>
  .mTips{
    width: 100vw;
    height: 100vh;
    background: #fff;
    .titleBox{
      padding-top: 48px;
      .title{
        line-height: 28px;
        margin-bottom: 4px;
      }
      .text{
        line-height: 20px;
      }
    }
    .linkBox{
      margin: 16px 28px 34px;
      height: 42px;
      line-height: 40px;
      border-radius: 24px;
      border: 1px solid #ECECEC;
      .link{
        margin: 0 22px;
      }
      .button{
        width: 78px;
        line-height: 40px;
        background: #EFF7FF;
        border-radius: 0 40px 40px 0;
      }
    }
    .qrCode{
      width: 236px;
      margin:0 auto 10px;
    }
    .tipsText{
      width: 100vw;
      line-height: 22px;
      margin-bottom: 4px;
    }
  }
</style>
<style lang="scss">
  body{
    min-width: auto;
    .pageContent{
      padding-left: 0;
    }
  }
  
  #udesk_container{
    display: none !important;
  }
</style>